import PropTypes from 'prop-types'
import React from "react"
import { Card, CardBody, Col } from "reactstrap"

const MiniCards = props => {
  const { title, text, iconClass, cardCol } = props
  return (
    <React.Fragment>
      <Col md={cardCol || 4}>
        <Card className="mini-stats-wid">
          <CardBody>
            <div className="d-flex">
              <div className="flex-grow-1">
                <p className="text-muted fw-medium mb-2 para">{title}</p>
                <h5 className="mb-0">{text}</h5>
              </div>
              <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span className="avatar-title">
                  <i className={"bx " + iconClass + " font-size-24"} />
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default MiniCards
